var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevOpsCi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0164 110.792V89.0933C29.7049 89.1097 34.3935 89.1097 39.082 89.1508C39.8785 89.1508 40.1577 88.8798 40.289 88.0913C41.2579 82.3341 43.0233 76.8315 45.6837 71.6245C46.8743 69.292 48.2127 67.0335 49.584 64.5614C46.2339 61.2188 42.8509 57.8515 39.5993 54.6074C44.6655 49.5401 49.6989 44.522 55.0197 39.2001C58.1646 42.4524 61.4079 45.8032 64.6595 49.1623C72.1234 43.8075 80.2606 40.3499 89.2845 38.6087V25H110.871V26.5358C110.871 30.1002 110.888 33.6728 110.855 37.2372C110.847 38.1324 110.978 38.5677 112.046 38.773C117.194 39.7339 122.17 41.319 126.842 43.6925C129.913 45.253 132.861 47.0598 136.112 48.8913C139.191 45.795 142.386 42.5838 145.399 39.545C150.441 44.5877 155.466 49.614 160.606 54.7635C157.469 57.8761 154.21 61.0956 150.95 64.3233C151.065 64.5779 151.114 64.775 151.213 64.931C155.901 72.0762 159.029 79.8374 160.499 88.272C160.557 88.617 161.263 89.0851 161.682 89.1015C164.81 89.1672 167.938 89.1426 171.059 89.1426C172.364 89.1426 173.67 89.1426 175.008 89.1426V110.734H160.179C158.373 119.391 154.908 127.259 149.644 134.601C153.364 138.28 157.001 141.877 160.68 145.516C158.143 148.054 155.614 150.567 153.101 153.088C150.597 155.593 148.092 158.106 145.366 160.833C141.523 156.973 137.828 153.244 134.125 149.515C127.715 153.173 120.221 156.206 111.643 158.615C111.307 158.714 110.904 159.354 110.904 159.74C110.863 164.824 110.896 169.9 110.904 174.984H89.2106V158.615C80.7779 157.03 73.1498 153.852 65.9897 149.056C62.1551 152.916 58.378 156.71 54.7077 160.398C49.6415 155.355 44.6081 150.345 39.5008 145.261C43.1711 141.606 46.899 137.894 50.5282 134.281C50.5118 134.026 50.5282 133.968 50.5036 133.927C49.9042 132.983 49.2966 132.038 48.7054 131.094C44.9693 125.14 42.3007 118.742 40.8145 111.859C40.6585 111.137 40.4368 110.685 39.5008 110.701C34.6644 110.775 29.8363 110.759 25 110.767L25.0164 110.792ZM56.2349 99.1869C56.1939 123.382 75.9662 143.298 100.066 143.348C124.584 143.397 144.332 123.784 144.422 99.2937C144.512 75.0164 124.781 55.133 100.534 55.0756C76.0729 55.0181 56.2678 74.7372 56.2349 99.1869Z",
    fill: "url(#paint0_linear_71_771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.287 63.855C119.813 63.8222 135.735 79.6977 135.743 99.2033C135.743 118.643 119.912 134.502 100.443 134.56C80.901 134.609 64.9633 118.791 64.9222 99.2854C64.8811 79.7798 80.745 63.8879 100.287 63.855ZM100.008 94.292C98.3577 92.4523 97.2082 90.8836 95.7876 89.6435C90.8856 85.3481 83.5039 85.3728 78.4458 89.5778C73.4699 93.7171 72.1397 100.936 75.3256 106.554C79.6036 114.101 89.5801 115.785 96.0668 110.036C97.4381 108.821 98.719 107.498 100.115 106.151C101.215 107.277 102.209 108.287 103.202 109.297C105.592 111.72 108.482 113.157 111.865 113.428C118.089 113.921 123.763 110.184 125.766 104.386C127.778 98.5627 125.553 92.0334 120.429 88.6743C115.174 85.2332 108.523 85.7588 103.826 90.0787C102.578 91.2285 101.535 92.6001 100.008 94.3084V94.292Z",
    fill: "url(#paint1_linear_71_771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8582 99.9343C92.5198 101.257 91.3785 102.521 90.0976 103.622C88.209 105.24 85.2941 105.002 83.6272 103.203C81.9029 101.347 81.9357 98.4067 83.7011 96.5917C85.4172 94.8341 88.2993 94.6699 90.1797 96.3207C91.4195 97.4048 92.5362 98.6285 93.8582 99.9261V99.9343Z",
    fill: "url(#paint2_linear_71_771)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.191 99.9423C107.546 98.62 108.679 97.4127 109.927 96.3204C111.808 94.6696 114.714 94.8503 116.43 96.6243C118.188 98.4393 118.179 101.445 116.43 103.26C114.714 105.034 111.824 105.215 109.927 103.564C108.679 102.48 107.546 101.265 106.199 99.9423H106.191Z",
    fill: "url(#paint3_linear_71_771)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_771",
    x1: 100.004,
    y1: 25,
    x2: 100.004,
    y2: 174.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_771",
    x1: 100.332,
    y1: 63.855,
    x2: 100.332,
    y2: 134.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_771",
    x1: 88.1067,
    y1: 95.1729,
    x2: 88.1067,
    y2: 104.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_771",
    x1: 111.968,
    y1: 95.1816,
    x2: 111.968,
    y2: 104.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsCi);
export default __webpack_public_path__ + "static/media/DevOps_&_CI.5f3e0535119eff5eae2ec28e89b47533.svg";
export { ForwardRef as ReactComponent };